function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M295,503.78v-18h11.53l4.59,5.06v12.89Zm1-17v16l14.13,0V491.26l-4-4.44Z",
  transform: "translate(-295 -485.81)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "15.83 5.75 10.71 5.75 10.71 0.69 11.71 0.69 11.71 4.75 15.83 4.75 15.83 5.75"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M308.8,497.78a.54.54,0,0,0-.17-.27,2.42,2.42,0,0,0-1.5-.34,13,13,0,0,0-1.8.13,4.5,4.5,0,0,1-.84-.55,5.77,5.77,0,0,1-1.51-2.22l.06-.22a13.74,13.74,0,0,0,.27-2.6.72.72,0,0,0,0-.19l0-.08a.65.65,0,0,0-.59-.43h-.18a.67.67,0,0,0-.68.41,7.17,7.17,0,0,0,.42,3.39l-.11.24c-.29.68-.66,1.36-1,2l0,.08c-.34.63-.65,1.17-.93,1.63l-.29.14-.63.33c-1,.56-1.64,1.19-1.75,1.7a.41.41,0,0,0,.17.46l.28.13a.9.9,0,0,0,.38.09c.7,0,1.52-.83,2.64-2.69a27.47,27.47,0,0,1,4.07-.92,7.3,7.3,0,0,0,3,.89,1.45,1.45,0,0,0,.35,0,.61.61,0,0,0,.35-.22A1.14,1.14,0,0,0,308.8,497.78Zm-10.67,3.28a4.69,4.69,0,0,1,1.39-1.57l.27-.24A4.86,4.86,0,0,1,298.13,501.05Zm4.44-9.71c.23,0,.35.54.37,1a2.06,2.06,0,0,1-.27,1.13,5.2,5.2,0,0,1-.19-1.4S302.47,491.34,302.57,491.34Zm-1.33,6.92.49-.85a15.49,15.49,0,0,0,.86-1.78,5.94,5.94,0,0,0,1.41,1.67l.22.17A18.72,18.72,0,0,0,301.25,498.26Zm7.16-.06a1.09,1.09,0,0,1-.39.06,4.82,4.82,0,0,1-1.63-.47l.75,0a3,3,0,0,1,.94.1C308.47,498,308.48,498.16,308.41,498.2Z",
  transform: "translate(-295 -485.81)"
});

var SvgFilesListingPdf = function SvgFilesListingPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    fill: "#434546",
    "data-name": "PDF Icon",
    viewBox: "0 0 16.13 17.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_pdf.a1710191.svg";
export { ForwardRef as ReactComponent };